import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

import BaseContainer from '../layout/container/BaseContainer'

//const Dashboard = () => import('@/layout/pages/Dashboard');
const FaqsPage = () => import('@/layout/pages/FaqsPage');
const Home = () => import('@/layout/pages/HomePage');
const FinalPage = () => import('@/layout/pages/shipment/FinalPage');
const AddressConfirmPage = () => import('@/layout/pages/shipment/AddressConfirmPage');
const DropNeighbourDeliveryPage = () => import('@/layout/pages/shipment/DropNeighbourDeliveryPage');
const ShipmentRejectPage = () => import('@/layout/pages/shipment/ShipmentRejectPage');
const DropDoorDeliveryPage = () => import('@/layout/pages/shipment/DropDoorDeliveryPage.vue');
const ChangeDeliveryDatePage = () => import('@/layout/pages/shipment/ChangeDeliveryDatePage.vue');
const ChangeDeliveryAddressPage = () => import('@/layout/pages/shipment/ChangeDeliveryAddressPage.vue');
const ManageDeliveryPage = () => import('@/layout/pages/shipment/DeliveryManagementPage.vue');
const LiveTrackingPage = () => import('@/layout/pages/shipment/LiveTrackingPage');

const DefaultPage = () => import('@/views/DefaultPage');
const NotFoundPage = () => import('@/views/NotFoundPage');
const ErrorPage = () => import('@/views/ErrorPage');

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'DefaultContainer',
    component: BaseContainer,
    redirect: '/base',
    children: [
      {
        path: 'home',
        component: () => import('@/layout/pages/Dashboard'), //import('@/layout/pages/HomePage.vue'), // 
        name: 'home',
      },
      {
        path: 'base',
        component: Home, //import('@/layout/pages/HomePage'), // HomePage
        name: 'base',
      },
      {
        path: 'notfound',
        component: NotFoundPage,
        name: 'notfound',
      },
      {
        path: 'error',
        component: ErrorPage,
        name: 'error',
      },
      {
        path: 'faqs',
        component: FaqsPage,
        name: 'Sıkça Sorulan Sorular',
      },
      {
        path: '/:token',
        component: DefaultPage,
        name: 'token',
      },
    ]
  },
  {
    path: '/shipment',
    name: 'ShipmentContainer',
    component: BaseContainer,// BackContainer,
    children: [
      {
        path:'final',
        component: FinalPage,
        name: 'Final'
      },
      {
        path: 'approve-address',
        component: AddressConfirmPage, //import('@/layout/pages/shipment/AddressConfirmPage'),
        name: 'Adresimdeyim'
      },
      {
        path:'neighbour-delivery',
        component: DropNeighbourDeliveryPage,
        name: 'Komşuma Bırak'
      },
      {
        path: 'drop-door-delivery',
        component: DropDoorDeliveryPage,
        name: 'Kapıma Bırak'
      },
      {
        path: 'reject',
        component: ShipmentRejectPage,
        name: 'İade Et'
      },
      {
        path: 'change-delivery-date',
        component: ChangeDeliveryDatePage,
        name: 'İstediğim Tarihte Gelsin'
      },
      {
        path:'change-delivery-address',
        component: ChangeDeliveryAddressPage,
        name: 'İstediğim Adrese Gelsin'
      },
      {
        path: 'manage-delivery',
        component: ManageDeliveryPage,
        name: 'Kargo Teslim Noktasından Al'
      },
      {
        path: 'live-tracking',
        component: LiveTrackingPage,
        name: 'Canlı Takip',
      },
    ]
  },
  {
    path: '*',
    component: BaseContainer,
    children: [
      {
        path: '*',
        component: Home,
        name: 'base',
      },
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

router.beforeEach((to, from, next) => {
  // explicitly return false to cancel the navigation
  //console.log(`From : ${from.path}, To: ${to.path}`);
  //console.log(`Store : ${ JSON.stringify(store.state) }`);
  store.state.showHeaderBackButton = false;
  store.state.showHeaderHelpButton = false;
  store.state.enableHeaderHomeButton = false;
  if(to.path == '/base'){
    store.state.maxWidth = 1920;
  } else {
    store.state.maxWidth = 412;
  }
  //console.log(`Store : ${ JSON.stringify(store.state) }`);
  //console.log(`this : ${ JSON.stringify(this.$screen) }`);
  
  return next();
})

export default router
